<template>
  <div class="container p-2">
    <h2 class="text-center mb-5 mt-5">Filas</h2>

    <vs-row>
      <vs-col
        class="mb-5"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <vs-button @click="buscarFilas">Atualizar</vs-button>
      </vs-col>
    </vs-row>

    <div class="vx-row">
      <div
        class="vx-col lg:w-1/2 w-full"
        v-for="(item, index) in filas"
        :key="index"
      >
        <vs-card>
          <div>
            <div class="mb-4">
              <span class="h5">Fila</span>
              <span class="h6">{{ item.fila }}</span>
            </div>

            <div class="mb-4">
              <span class="h5">Total de Registros</span>
              <span class="h6">{{ item.registros }}</span>
            </div>

            <div class="mb-4" v-if="item.dataUltimoProcessamento">
              <span class="h5">Último Processamento</span>
              <span class="h6">
                {{
                  formataData(item.dataUltimoProcessamento, 'DD/MM/YYYY HH:mm')
                }}
              </span>
            </div>

            <div class="mb-4 pb-4">
              <span class="h5">Status</span>

              <vs-chip v-if="item.status" :color="chip(item)">{{
                item.status
              }}</vs-chip>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import service from '../../services/';
import notify from '../../utils/notify';
import functions from '../../utils/functions';

export default {
  data() {
    return {
      filas: [],
      formataData: functions.formataDataMomentJS,
    };
  },
  mounted() {
    this.buscarFilas();
    this.atualizar3Minutos();
  },
  methods: {
    async buscarFilas() {
      try {
        this.$vs.loading();
        const { data } = await service.getAll('AdmFilas', null, 'buscar-filas');
        this.ordenar(data);
        this.$vs.loading.close();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    atualizar3Minutos() {
      setInterval(async () => {
        this.buscarFilas();
      }, 180000);
    },
    ordenar(dados) {
      this.filas = dados.sort((a, b) => {
        return b.fila < a.fila ? 0 : -1;
      });
    },
    chip(item) {
      return item.status === 'Sucesso' ? 'success' : 'danger';
    },
  },
};
</script>

<style scoped>
span {
  display: block;
  margin-bottom: 4px;
}

span.h5 {
  color: #00bfed;
}
</style>
